import { $api } from "../generated/client";

export default function useListSizingExperiments(shopId: string) {
	return $api.useQuery("get", "/shops/{shopId}/sizing/experiments", {
		params: { path: { shopId } },
		enabled: !!shopId,
	});
}
